export default "__VITE_ASSET__D$VlwIlG__"